<template>
  <div>
    <a
      class="block block-bordered text-center d-sm-none"
      href="javascript:void(0)"
      data-toggle="class-toggle"
      data-target=".js-classic-nav"
      data-class="d-none d-sm-block"
    >
      <div class="block-content block-content-full text-center">
        <div class="font-w600 text-uppercase">
          <i class="fa fa-bars mr-1"></i> Navigation
        </div>
      </div>
    </a>
    <div class="block block-bordered js-classic-nav d-none d-sm-block">
      <div class="block-content block-content-full">
        <div class="row no-gutters border">
          <div class="col-sm-3 col-xl-3">
            <a
              :class="
                this.$route.path === '/forms' || this.$route.path === '/'
                  ? 'block block-bordered block-link-pop text-center mb-0 navActive'
                  : 'block block-bordered block-link-pop text-center mb-0'
              "
              href="/forms"
            >
              <div class="block-content block-content-full text-center">
                <i
                  class="fab fa-2x fa-wpforms text-primary d-none d-sm-inline-block mb-3"
                ></i>
                <div class="font-w600 text-uppercase">Forms</div>
              </div>
            </a>
          </div>
          <div class="col-sm-3 col-xl-3">
            <a
              :class="
                this.$route.path === '/widgets'
                  ? 'block block-bordered block-link-pop text-center mb-0 navActive'
                  : 'block block-bordered block-link-pop text-center mb-0'
              "
              href="/widgets"
            >
              <div class="block-content block-content-full text-center">
                <i
                  class="fas fa-2x fa-box text-primary d-none d-sm-inline-block mb-3"
                ></i>
                <div class="font-w600 text-uppercase">Widgets</div>
              </div>
            </a>
          </div>
          <div class="col-sm-3 col-xl-3">
            <a
              :class="
                this.$route.path === '/submits'
                  ? 'block block-bordered block-link-pop text-center mb-0 navActive'
                  : 'block block-bordered block-link-pop text-center mb-0'
              "
              href="/submits"
            >
              <div class="block-content block-content-full text-center">
                <i
                  class="fas fa-2x fa-envelope-open-text text-primary d-none d-sm-inline-block mb-3"
                ></i>
                <div class="font-w600 text-uppercase">Submits</div>
              </div>
            </a>
          </div>
          <div class="col-sm-3 col-xl-3">
            <a
              :class="
                this.$route.path === '/formManager2'
                  ? 'block block-bordered block-link-pop text-center mb-0 navActive'
                  : 'block block-bordered block-link-pop text-center mb-0'
              "
              href="/formManager2"
            >
              <div class="block-content block-content-full text-center">
                <i
                  class="fas fa-2x fa-envelope-open-text text-primary d-none d-sm-inline-block mb-3"
                ></i>
                <div class="font-w600 text-uppercase">Form Manager 2</div>
              </div>
            </a>
          </div>
          <!-- <div class="col-sm-3 col-xl-3">
            <a
              :class="
                this.$route.path === '/users'
                  ? 'block block-bordered block-link-pop text-center mb-0 navActive'
                  : 'block block-bordered block-link-pop text-center mb-0'
              "
              href="/users"
            >
              <div class="block-content block-content-full text-center">
                <i
                  class="fas fa-2x fa-users text-primary d-none d-sm-inline-block mb-3"
                ></i>
                <div class="font-w600 text-uppercase">Users</div>
              </div>
            </a>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navigator"
};
</script>

<style scoped>
.navActive {
  background: #f4f6fa;
}
</style>
